import axios from "axios";

const axiosV2Instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

axiosV2Instance.interceptors.request.use(
  async (config) => {
    try {
      if (window.shopify?.idToken) {
        config.headers["Authorization"] = await window.shopify.idToken();
      }

      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosV2Instance;
